const palette = {
  primary: {
    main: "#555846",
    contrastText: "#FFFFFF",
  },
  secondary: {
    main: "#7F8466",
    contrastText: "#ffffff",
  },
  text: {
    primary: "#000000",
    
  },
  success: {
    main: "#0E912C",
  },
  common: {
    black: "#000000",
    white: "#FFFFFF",
  },
};

export default palette;
